import { FC } from "react";
import {
  Badge,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import Bookmark from "@mui/icons-material/Bookmark";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { isEmpty } from "lodash";
import __ from "src/utils/Translations";
import PlannedDayBadge from "src/Pages/Company/Absences/Calendars/Calendar/PlannedDayBagde";
import { IAbsenceGroup } from "src/Pages/Company/Absences/AbsenceGroups/AbsenceGroups.models";

interface ICalendarLegendProps {
  absenceGroupInfos: IAbsenceGroup[];
}

type ILegendItem = Omit<
  IAbsenceGroup,
  | "ownerId"
  | "presenceType"
  | "order"
  | "active"
  | "assignedAbsenceTypesCount"
  | "eTag"
> & {
  hidePrefix?: boolean;
};

const CalendarLegend: FC<ICalendarLegendProps> = ({ absenceGroupInfos }) => {
  if (isEmpty(absenceGroupInfos)) return null;

  const legendList: ILegendItem[] = [
    ...absenceGroupInfos,
    {
      color: "grey.200",
      id: "waiting-for-approval",
      name: __("Wniosek oczekuje na akceptację"),
      hidePrefix: true,
    },
    {
      color: "grey.800",
      id: "multiple-requests",
      name: __("Został złożony więcej niż jeden wniosek tego dnia"),
      hidePrefix: true,
    },
  ];

  return (
    <>
      <Typography variant="subtitle1" component="h2" sx={{ mb: "1.5rem" }}>
        {__("Legenda")}:
      </Typography>
      <Paper sx={{ padding: "1rem" }} data-testid="absences-calendar-legend">
        <List dense sx={{ display: "flex", flexWrap: "wrap" }}>
          {legendList.map((group) => (
            <ListItem
              key={group.id}
              sx={{ width: "auto" }}
              data-testid="absences-calendar-legend__item"
            >
              <ListItemIcon sx={{ minWidth: "2.5rem" }}>
                <Bookmark sx={{ color: group.color }} />
              </ListItemIcon>
              <ListItemText slotProps={{ primary: { variant: "subtitle1" } }}>
                {!group.hidePrefix && __("Wniosek o")} {group.name}
              </ListItemText>
            </ListItem>
          ))}
          <ListItem>
            <ListItemIcon sx={{ minWidth: "2.5rem" }}>
              <PlannedDayBadge data-testid="absences-calendar-day__planned">
                <BookmarkBorderOutlinedIcon />
              </PlannedDayBadge>
            </ListItemIcon>
            <ListItemText
              slotProps={{ primary: { variant: "subtitle1" } }}
              data-testid="absences-calendar-legend__item-plans"
            >
              {__("Zaplanowane nieobecności")}
            </ListItemText>
          </ListItem>
        </List>
      </Paper>
    </>
  );
};

export default CalendarLegend;
